export enum CommunicationMethod {
  Phone = 2,
  'In-person' = 1,
  Email = 3,
  Online = 5,
  Fax = 8,
  Other = 7,
}

export type Species = {
  id: number;
  value: string;
};

export type ClientCommunicationOption = {
  id: number;
  isPrimary: boolean;
  communicationMethodId: number;
  value: string | null;
  phoneTypeId: number | null;
  allowMessaging: boolean;
  isSuppressed: boolean | null;
};

export type Patient = {
  localId: string | null;
  petName: string;
  birthday: Date | null;
  color: string | null;
  breed: string | null;
  species: string;
  deathDate: Date | null;
  sexId: number | null;
  microchipId: string | null;
  wasEuthanized: boolean | null;
};

export type Client = {
  localId: string | null;
  firstName: string;
  lastName: string;
};
export enum DigitalFormBackgroundTheme {
  Stationary = 1,
  Paws = 2,
  PurpleAbstract = 3,
  Mint = 4,
}

export type ClientForm = {
  id: number;
  statusId: number;
  createdAt: Date;
  createdByUserId: number;
  digitalFormId: number;
  clientName: string;
  internalNote: string | null;
  patientId: number | null;
  clientId: number | null;
  hospitalId: number;
  email: string | null;
  phoneNumber: string | null;
  uuid: string;
  surveyJson: string;
  surveyThemeJson: Record<string, any> | null;
  responseJson: string | null;
  completedAt: Date | null;
  species: Species[];
  backgroundThemeId: DigitalFormBackgroundTheme;
  formLayoutVersion?: number;
  patient: Patient | null;
  client: Client | null;
};

export type FormVerificationMetadata = {
  uuid: string;
  requiresVerification: true;
};

export const isVerificationRequired = (data: ClientForm | FormVerificationMetadata): data is FormVerificationMetadata => {
  return 'requiresVerification' in data && data.requiresVerification === true && !('surveyJson' in data);
};
